/**
 * Footer menu columns: optional mobile-only accordion (section setting
 * "Collapse into an accordion on mobile"). The toggle buttons only render
 * when that setting is on; the collapse/expand itself is CSS (scoped to a
 * max-width media query in section-footer.css) so this click handler is
 * harmless no-op styling on desktop regardless of the .active state.
 */
document.addEventListener('DOMContentLoaded', function () {
  var toggles = document.querySelectorAll('.spi_main-footer-accordion-toggle');
  if (!toggles.length) return;

  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var wrapper = toggle.closest('.spi_main-footer-links-wrapper');
      if (!wrapper) return;

      var isActive = wrapper.classList.toggle('active');
      toggle.setAttribute('aria-expanded', String(isActive));
    });
  });
});
